export default __webpack_public_path__ + "static/media/Janek Kulka.1d607513.png";